module.exports = __webpack_public_path__ + "static/media/4.e7711e91.jpeg";